import track from '../Gated/src/tracking/eventTracker';

const WaysToWearItEventTracker = {
  trackCarouselSeenInViewport: ({
    carouselOutfitIds,
    collection,
    pdpOutfitId,
    pdpSkuId,
    externalProductId,
    source,
    subSource,
  }) => {
    return track({
      action_name: 'ways_to_wear_it_view',
      action_type: 'view',
      canonical_name: 'pdp',
      carousel_outfit_ids: carouselOutfitIds,
      collection,
      event_name: 'pdp.ways_to_wear_it.view',
      pdp_sku_id: pdpSkuId,
      external_product_id: externalProductId,
      referring_outfit_id: pdpOutfitId,
      sku_id: pdpSkuId,
      source,
      sub_source: subSource,
    });
  },
  trackOutfitSeen: ({
    carouselOutfitIds,
    collection,
    outfitId,
    pdpSkuId,
    externalProductId,
    source,
    subSource,
  }) => {
    return track({
      action_name: 'ways_to_wear_it_outfit_view',
      action_type: 'view',
      canonical_name: 'pdp',
      carousel_outfit_ids: carouselOutfitIds,
      collection,
      event_name: 'pdp.ways_to_wear_it.view',
      pdp_sku_id: pdpSkuId,
      external_product_id: externalProductId,
      outfit_id: outfitId,
      sku_id: pdpSkuId,
      source,
      sub_source: subSource,
    });
  },
  trackOutfitItemClicked: ({
    outfitId,
    collection,
    pdpSkuId,
    externalProductId,
    source,
    subSource,
  }) => {
    return track({
      action_name: 'ways_to_wear_it_outfit_item_clicked',
      action_type: 'click',
      canonical_name: 'pdp',
      collection,
      outfit_id: outfitId,
      event_name: 'pdp.ways_to_wear_it.outfit_item.click',
      pdp_sku_id: pdpSkuId,
      sku_id: pdpSkuId,
      external_product_id: externalProductId,
      source,
      sub_source: subSource,
    });
  },
  trackAccordionFolded: ({
    carouselOutfitIds,
    collection,
    pdpSkuId,
    externalProductId,
    source,
    subSource,
    expanded,
  }) => {
    return track({
      action_name: 'ways_to_wear_it_accordion_clicked',
      action_type: 'click',
      canonical_name: 'pdp',
      carousel_outfit_ids: carouselOutfitIds,
      collection,
      event_name: 'pdp.ways_to_wear_it.accordion.click',
      expanded,
      pdp_sku_id: pdpSkuId,
      sku_id: pdpSkuId,
      external_product_id: externalProductId,
      source,
      sub_source: subSource,
    });
  },
  trackJumpLinkClicked: ({
    outfitId,
    collectionName,
    skuId,
    source,
    externalProductId,
  }) => {
    return track({
      action_name: 'ways_to_wear_it_jump_link',
      action_type: 'click',
      canonical_name: 'pdp',
      outfit_id: outfitId,
      collection: collectionName,
      event_name: 'pdp.ways_to_wear_it.jump_link_click',
      sku_id: skuId,
      external_product_id: externalProductId,
      source,
    });
  },
};

export default WaysToWearItEventTracker;
